import React from 'react';

import RegularRate from '../rates/RegularRate.jsx';
import SlotName from './SlotName.jsx';

export default class SingleOutcomeSlot extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        sportId: React.PropTypes.number.isRequired,
        match: React.PropTypes.object,
        slot: React.PropTypes.object.isRequired,
        outcomes: React.PropTypes.array.isRequired,
        gridLocalization: React.PropTypes.object.isRequired
    };

    shouldComponentUpdate(nextProps) {
        return this.props.gridLocalization !== nextProps.gridLocalization ||
            this.props.slot !== nextProps.slot ||
            this.props.outcomes !== nextProps.outcomes;
    }

    render() {
        const {section, sportId, slot, match, gridLocalization, outcomes} = this.props;

        const outcome = outcomes[0];
        const outcomeRates = [];

        outcome.get('rates')
            .entrySeq()
            .sortBy((r) => r[0])
            .forEach((r) => {
                outcomeRates.push(r[1]);
            });

        const slotNameProps = {
            sportId,
            match,
            slot,
            outcome,
            gridLocalization
        };

        const props = {
            section,
            gridLocalization
        };

        return (
            <div className="table detailed">
                <div className="row inner">
                    <div className="cell main">
                        <SlotName {...slotNameProps}/>
                    </div>

                    <div className="cell rate ss">
                        <div className="rates">
                            {outcomeRates.map((r) => <RegularRate key={r} id={r} {...props} />)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/slots/SingleOutcomeSlot.jsx